export const appConfig =
{
    //staging url
    // base_url: 'https://staging.tgchat.app/',
    // tabib_base_url : 'http://ec2-52-4-186-178.compute-1.amazonaws.com/'


    //live url
    base_url: 'https://tgchat.app/',
    tabib_base_url : 'https://tabibgroup.net/'



    //////////////////////////////////////////
    // url = 'localhost/';
    //old stagging url
    // url = 'http://52.59.247.72/';
}



// WEBPACK FOOTER //
// ./src/config.ts